import ApiClient from '@/api/api-client'

export default function() {
    return {
        login: function(credentials) {
            return ApiClient.post('/login', credentials)
        },

        logout: function() {
            return ApiClient.get('/logout')
        }
    }
}
